import React, { useState } from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player/youtube";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SynthesiaVideo from "../microSites/edit/tabs/SynthesiaVideo";

export default function ImageSlider({ data }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    // Add this callback to track slide changes
    afterChange: (index) => {
      setCurrentSlide(index);
    },
  };

  if (data && data?.length > 0 && data[0]?.id) {
    return (
      <div className="custom-slider-container">
        <Slider {...settings}>
          {data &&
            data?.map((item, i) => {
              if (
                item?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <ReactPlayer
                      controls={true}
                      url={item.mediaLink.url}
                      width={"100%"}
                    />
                  </div>
                );
              } else if (
                item?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <iframe
                      title="Embedded video"
                      controls={true}
                      src={item.mediaLink.url}
                      width="100%"
                      style={{ backgroundColor: "black" }}
                    />
                  </div>
                );
              } else if (
                (item?.mediaLink?.mediaType === "IMAGE" ||
                  item?.mediaLink?.mediaType === "GIF") &&
                (item.mediaLink.url || item.mediaLink.gifCreator?.previewUrl)
              ) {
                const imageSrc =
                  item.mediaLink.gifCreator?.previewUrl || item.mediaLink.url;
                return (
                  <div key={i} className="slide">
                    <div className="img-slide" style={{ backgroundColor: 'white' }}>
                      <img
                        src={imageSrc}
                        alt={item?.title || ""}
                        className="c1 carousel-image"
                      />
                    </div>
                  </div>
                );
              }
              else if (
                item?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
                item.mediaLink.url) {
                return (
                  <div className="synthesia-video-container" style={{ width: "350px", height: '250px', margin: "0 auto" }}>
                    <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
                      <SynthesiaVideo key={item.id} videoData={item} />
                    </div>
                  </div>
                )
              }
              return null;
            })}
        </Slider>

        <div className="slide-title">
          {data[currentSlide]?.title || "No title"}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}